import React, { useState, useEffect, useRef } from 'react';
import { useStateValue } from '../StateProvider';
import axios from 'axios';
import configData from '../Config.json';
import Select from '../Components/select.js';

import { getPermission } from '../Utils/permissions.js';
import Title from '../Title';

const posTypes = [
    {
        id: "supermarket",
        name: "Supermarket",
        description: "For grocery stores, mini-markets, and retail shops managing barcodes, stock, and checkout counters."
    },
    {
        id: "restaurant",
        name: "Restaurant",
        description: "For restaurants and cafés managing menus, tables, orders, and kitchen operations."
    },
    {
        id: "hospitality",
        name: "Hospitality",
        description: "For hotels, resorts, and guesthouses handling room management and guest billing."
    },
    {
        id: "service",
        name: "Service",
        description: "For service-based businesses like salons, clinics, and repair shops managing appointments and payments."
    },
    {
        id: "manufacturing",
        name: "Manufacturing",
        description: "For industrial or factory setups tracking production, warehouse inventory, and internal sales."
    },
    {
        id: "wholesale",
        name: "Wholesale",
        description: "For bulk and B2B sellers managing large orders, tiered pricing, and invoices."
    }
];

function Pos({ state, setState }) {
    const [{ project }, dispatch] = useStateValue();

    const [typeid, setTypeid] = useState('');
    const [margin, setMargin] = useState(0);

    const [result, setResult] = useState(null);
    const [loading, setLoading] = useState(false);

    const inputRef = useRef(null);

    useEffect(() => {
        setTypeid(project.postypeid);
    }, [project]);

    const handleSubmit = () => {
        console.log('Trying to save pos type');

        setResult('');

        const hasPermission = getPermission(
            project.projectuserid,
            project.users,
            state.user.userid,
            'Settings',
            'update',
            project.archived
        );
        if (hasPermission.code == 0) {
            setResult(hasPermission.data);
            return;
        }

        setLoading(true);

        const data = {
            projectuserid: project.projectuserid,
            projectid: project.projectid,
            posttypeid: typeid
        }

        axios.post(configData.CONTROLLERURL + configData.UPDATEPOSTYPE, data, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                "userid": state.user.userid,
                "usertoken": state.user.usertoken
            }
        }).then((res) => {
            console.log('Save project details data received')
            console.log(res.data)
            if (res.data instanceof Object) {
                if (res.data.code === 1) {
                    setResult('Success')
                    dispatch({
                        type: 'UPDATE_POSTTYPE',
                        posttypeid: typeid,
                    });
                }
                else {
                    setResult(res.data.data)
                }
            }
            else {
                setResult('Error');
            }
        }).catch((err) => {
            setResult(err.response?.data?.message || err.message || 'Network error');
        }).finally(() => {
            setLoading(false);
        });
    };

    return (
        <div className='pos'>
            <Title text='POS' />
            <div className='modal_row'>
                <div className='modal_rowsection'>
                    <div className='settings_label'>POS Configuration</div>
                </div>
            </div>

            <div className='modal_row'>
                <div className='modal_rowsection'>
                    <Select data={posTypes} itemid={typeid} setItemid={setTypeid} />
                </div>
            </div>

            <div className='modal_row'>
                <div className='modal_rowsection'>
                    {posTypes.find(t => t.id === typeid)?.description}
                </div>
            </div>

            <div className='modal_row'>
                <div className='modal_rowsection'>
                    <div className='settings_label'>Profit margin target (%)</div>
                </div>
            </div>

            <div className='modal_row'>
                <div className='modal_rowsection'>
                    <input
                        className='modal_input'
                        type='number'
                        value={margin}
                        onChange={e => setMargin(e.target.value)}
                    />
                </div>
            </div>

            <div className='result'>{result && result}</div>
            <div className='buttonscontainer'>
                <button className='button' onClick={handleSubmit} disabled={loading}>{loading ? 'Loading...' : 'Save'}</button>
            </div>
        </div >
    );
}

export default Pos;